import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=2ecd1bb8&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd1bb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecd1bb8')) {
      api.createRecord('2ecd1bb8', component.options)
    } else {
      api.reload('2ecd1bb8', component.options)
    }
    module.hot.accept("./coupon.vue?vue&type=template&id=2ecd1bb8&scoped=true&", function () {
      api.rerender('2ecd1bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/coupon.vue"
export default component.exports